import React, { useEffect, useState } from "react";
import Layout2 from "../components/Layout/Layout2";
import SectionHeading from "../components/Items/SectionHeading";

export const certificateItems = [
  {
    id: 1,
    title: "Index Match, VLOOKUP & HLOOKUP in Excel",
    image: "/images/certificates/certificate-1.jpg",
    alt: "Certificate 1",
    category: "course",
  },
  {
    id: 2,
    title: "Data Analysis Fundamentals",
    image: "/images/certificates/certificate-2.jpg",
    alt: "Certificate 2",
    category: "course",
  },
  {
    id: 3,
    title: "Software Engineer Certification BNSP",
    image: "/images/certificates/certificate-3.jpg",
    alt: "Certificate 3",
    category: "course",
  },
  {
    id: 4,
    title: "Data Analyst Training Program",
    image: "/images/certificates/certificate-4.jpg",
    alt: "Certificate 4",
    category: "course",
  },
  {
    id: 5,
    title: "Infographic Competition — 1st Place",
    image: "/images/certificates/lomba1.png",
    alt: "Sertifikat Lomba Data Analysis",
    category: "competition",
  },
  {
    id: 6,
    title: "Technology Business Plan — 1st Place",
    image: "/images/certificates/lomba2.png",
    alt: "Sertifikat Lomba Presentasi",
    category: "competition",
  },
  {
    id: 7,
    title: "Poster Competition — 1st Place",
    image: "/images/certificates/lomba3.jpg",
    alt: "Sertifikat Lomba Desain",
    category: "competition",
  },
    {
    id: 8,
    title: "Poster Competition — 2nd Place",
    image: "/images/certificates/lomba4.jpg",    
    alt: "Sertifikat Lomba Desain",
    category: "competition",
  },
    {
    id: 9,
    title: "Poster Competition — 2nd Place",
    image: "/images/certificates/lomba5.png",
    alt: "Sertifikat Lomba Desain",
    category: "competition",
  },
];

export function CertificateGallery({ showIntro = true }) {
  const [selectedImage, setSelectedImage] = useState(null);
  const groupedCertificates = {
    course: certificateItems.filter((item) => item.category === "course"),
    competition: certificateItems.filter(
      (item) => item.category === "competition"
    ),
  };

  const renderCertificateGrid = (items) => (
    <div className="certificate-grid">
      {items.map((item) => (
        <button
          type="button"
          className="certificate-card"
          key={item.id}
          onClick={() => setSelectedImage(item)}
        >
          <div className="certificate-image-wrap">
            <img
              src={item.image}
              alt={item.alt}
              className="certificate-image"
            />
            <div className="certificate-overlay">
              <span>View</span>
            </div>
          </div>
          <div className="certificate-content">
            <h5>{item.title}</h5>
          </div>
        </button>
      ))}
    </div>
  );

  return (
    <>
      {showIntro && (
        <div className="certificate-gallery-intro">
          <p>
            A collection of training, course, and achievement certificates that
            reflect my dedication to learning and professional growth.
          </p>
        </div>
      )}

      <div className="certificate-group">
        <h4 className="certificate-group-title">Certification, Training, and Course</h4>
        {renderCertificateGrid(groupedCertificates.course)}
      </div>

      <div className="certificate-group">
        <h4 className="certificate-group-title">Competition Certificates</h4>
        {renderCertificateGrid(groupedCertificates.competition)}
      </div>

      {selectedImage && (
        <div
          className="certificate-lightbox"
          onClick={() => setSelectedImage(null)}
          role="dialog"
          aria-modal="true"
        >
          <div
            className="certificate-lightbox-content"
            onClick={(e) => e.stopPropagation()}
          >
            <button
              type="button"
              className="certificate-close"
              onClick={() => setSelectedImage(null)}
              aria-label="Close certificate"
            >
              ×
            </button>
            <img src={selectedImage.image} alt={selectedImage.alt} />
            <h4>{selectedImage.title}</h4>
          </div>
        </div>
      )}
    </>
  );
}

function Certificates() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <Layout2>
      <section className="shadow-blue white-bg padding mt-0">
        <SectionHeading title="Certificates" />
        <CertificateGallery />
      </section>
    </Layout2>
  );
}

export default Certificates;
